export const OVERVIEW_PATH = '/invoices';
export const OVERVIEW_FINISHED_PATH = '/invoices/finished';
export const OVERVIEW_TESTING_PATH = '/invoices/testing';

export const CHANNEL_PATH = '/invoices/channels/:channelId';
export const CHANNEL_FINISHED_PATH = '/invoices/channels/:channelId/finished';
export const CHANNEL_TESTING_PATH = '/invoices/channels/:channelId/testing';
export const CHANNEL_CONFIG_PATH = '/invoices/channels/:channelId/config/:tab?/:configId?';
export const CHANNEL_MASTERDATA_PATH = '/invoices/channels/:channelId/masterdata';

export const ASSISTANCE_PATH = '/invoices/:recordId';
export const ASSISTANCE_TAB_PATH = '/invoices/:recordId/:tab';
